export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/6ca19e876096cae3e2ee3e269668428e.svg";